import axios from 'axios';
import { appConfig } from '../utils/appConfig';
import { getAuthToken } from './authToken';

/**
 * Authenticated axios instance.
 * Automatically injects the Bearer token from localStorage on every request.
 */
export const apiClient = axios.create({
  baseURL: appConfig.apiBaseUrl,
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token && config.headers) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject(error)
);

/**
 * Unauthenticated axios instance for public endpoints.
 */
export const publicApiClient = axios.create({
  baseURL: appConfig.apiBaseUrl,
  headers: { 'Content-Type': 'application/json' },
});
